import { render, staticRenderFns } from "./modifiers.vue?vue&type=template&id=01f1ed20&"
import script from "./modifiers.vue?vue&type=script&lang=js&"
export * from "./modifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports